import React from 'react';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import createMuiTheme from 'material-ui/styles/createMuiTheme'
import blue from 'material-ui/colors/blue';
import pink from 'material-ui/colors/pink';
import red from 'material-ui/colors/red';

const theme = createMuiTheme({
    palette: {
        primary: blue,
        secondary: pink,
        error: red
    },
});

const ModalThemeProvider = props => {
    return (
        <MuiThemeProvider theme={theme}>
            {props.children}
        </MuiThemeProvider>
    )
}

export default ModalThemeProvider


// WEBPACK FOOTER //
// ./src/components/modals/ModalThemeProvider.js